import React , { useState, useEffect } from 'react';
import { Pagination, Dropdown, Checkbox, Form, Button, Table } from 'semantic-ui-react'
import './App.css';

function App() {
  const URL ='https://nevezes.diakolimpia.hu';

  const pageSize = 10;

  const [state, setState] = useState({
      currentPage : 1,
      pageCount: 0,
      isLoading: true,
      error: null,
      header: [
          {key: "tanev",          value: "Tanév",           text: "Tanév",              isShow: true},
      //    {key: "omAzon",         value: "OM azonosító",    text: "OM azonosító",       isShow: false},
          {key: "nev",            value: "Versenyző név",   text: "Versenyző név",      isShow: true},
      //    {key: "szulHely",       value: "Születési hely",  text: "Születési hely",     isShow: false},
          {key: "szulIdo",        value: "Születési hely",  text: "Születési idő",      isShow: false},
        //  {key: "anyjaNeve",      value: "Anyja neve",      text: "Anyja neve",         isShow: false},
          {key: "fhely", value: "Feladatelltási hely",      text: "Feladatellátási hely",         isShow: false},
          {key: "fhelyTelepules", value: "F.hely település",      text: "F.hely település",         isShow: false},
          {key: "versenyKiiras",  value: "Versenykiírás",   text: "Versenykiírás",      isShow: true},
          {key: "versenyresz",    value: "Versenyszám",     text: "Versenyszám",        isShow: true},
          {key: "nem",    value: "Nem",     text: "Nem",        isShow: false},
          {key: "jelleg",    value: "Jelleg",     text: "Jelleg",        isShow: false},
          {key: "korcsoport",    value: "Korcsoport",     text: "Korcsoport",        isShow: false},
          {key: "kategoria",    value: "Kategória",     text: "Kategória",        isShow: false},
          {key: "helyszin",    value: "Helyszín",     text: "Helyszín",        isShow: false},
          {key: "idopont",    value: "Időpont",     text: "Időpont",        isShow: false},
          {key: "helyezes",       value: "Helyezés",        text: "Helyezés",           isShow: true},

      ],
      items: null,

      tanev: '',
      nev: '',
      versenyKiiras: '',
      versenyresz: '',
      helyezes: '',

      direction: null,
      column: null,
  });

  useEffect(() => {
      fetchLength();
      fetchTable();
  }, [state.currentPage, state.column, state.direction]);

  const pageClick = (e, d) => {
      const { activePage = 1 } = d || {};
      setState((prev)=>{
          return {...prev, currentPage: activePage}
      });
  }

  const tableColumChange = (event, data, key) => {
    event.stopPropagation()
    event.nativeEvent.stopImmediatePropagation()
    const headers = state.header;

    for (let index = 0; index < headers.length; index++) {
      if(headers[index].key === key){
        headers[index].isShow = data.checked;
      }
    }

    setState((prev)=>{
      return {...prev, header: headers}
    });

  }

  const submitFilter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    setState((prev)=>{
      return {...prev, currentPage: 1}
    });

    if(state.currentPage === 1){
      fetchTable(1);
      fetchLength();
    }
  }
  const fetchLength = () => {
    fetch(`${URL}/pub/api/igazolasok/page-count?size=${pageSize}${state.nev ? '&nev='+state.nev: ''}`
    + `${state.tanev ? '&tanev='+state.tanev: ''}${state.helyezes ? '&helyezes='+state.helyezes: ''}${state.versenyresz ? '&versenyresz='+state.versenyresz: ''}${state.versenyKiiras ? '&versenyKiiras='+state.versenyKiiras: ''}`
    )
      .then(res => res.json())
      .then(
          (result) => {
              setState((prev)=>{
                  return {...prev, pageCount: result}
              });
          },
          (error) => {
              setState((prev)=>{
                  return {...prev, error}
              });
          }
      );
  }

  const fetchTable = (page = null) => {
      fetch(`${URL}/pub/api/igazolasok?page=${page || state.currentPage}&size=${pageSize}${state.nev ? '&nev='+state.nev: ''}`
        + `${state.tanev ? '&tanev='+state.tanev: ''}${state.helyezes ? '&helyezes='+state.helyezes: ''}${state.versenyresz ? '&versenyresz='+state.versenyresz: ''}${state.versenyKiiras ? '&versenyKiiras='+state.versenyKiiras: ''}`
        + `${state.direction === 'ascending' ?  '&sort='+state.column+'&order=asc' : ''}`
        + `${state.direction === 'descending' ? '&sort='+state.column+'&order=desc' : ''}`
      )
          .then(res => res.json())
          .then(
              (result) => {
                  setState((prev)=>{
                      return {...prev, isLoading:false, items: result}
                  });
              },
              (error) => {
                  setState((prev)=>{
                      return {...prev, isLoading:false, error}
                  });
              }
          )
  }

  const changeInput = (e, d, name) => {
    setState((prev)=>{
      return {...prev, [name]:d.value}
    });
  } 

  const handleSort = (clickedColumn) => () => {
    const { column, direction } = state

    if (column !== clickedColumn) {
      setState((prev)=>{
        return {...prev, column: clickedColumn, direction: 'ascending'}
      });

      return
    }

    setState((prev)=>{
      return {...prev, direction: direction === 'ascending' ? 'descending' : 'ascending'}
    });

  }

  if (state.error) {
      return <div>Error: {state.error.message || "Ismretlen hiba!"}</div>;
  } else if (state.isLoading) {
      return <div>Loading...</div>;
  } else {
      return ([
      <Form onSubmit={(e,d)=>{ submitFilter(e,d)}}>
        <Form.Group>
          <Form.Input style={{width: '75px'}} onChange={(e, d) => changeInput(e, d, 'tanev')} value={state.tanev} label='Tanév' placeholder='Tanév' state=''/>
          <Form.Input onChange={(e, d) => changeInput(e, d, 'nev')} value={state.nev} label='Versenyző név' placeholder='Versenyző név' />
          <Form.Input style={{width: '100px'}} onChange={(e, d) => changeInput(e, d, 'versenyKiiras')} value={state.versenyKiiras} label='Versenykiírás' placeholder='Versenykiírás' />
          <Form.Input onChange={(e, d) => changeInput(e, d, 'versenyresz')} value={state.versenyresz} label='Versenyszám' placeholder='Versenyszám' />
          <Form.Input style={{width: '90px'}} onChange={(e, d) => changeInput(e, d, 'helyezes')} value={state.helyezes} label='Helyezés' placeholder='Helyezés' />
          <Button style={{height: 'fit-content',display: 'inline-flex',alignSelf: 'flex-end'}}>Szűrés</Button>
        </Form.Group>
        
      </Form>,
      <div style={{overflowX: 'auto'}}>
        <CostumTable header={state.header} items={state.items} pageCount={state.pageCount} 
        page={state.currentPage} pageClick={pageClick} tableColumChange={tableColumChange} handleSort={handleSort}
        direction={state.direction}
        column={state.column}
        />
      </div>
      ]);
  }
}


function CostumTable({header, items, pageCount, page, pageClick, tableColumChange, handleSort, column , direction}){

  const keys = header.filter(e => e.isShow).map( e => e.key);

  return(
      <Table className="ui line celled unstackable bottom attached table sortable" sortable={true}>
        <Table.Header>
          <Table.Row>
            {   header.map( (e, i) => {
                      const { key = "", value = "", isShow = true } = e || {};
                      if(isShow){
                          return (<Table.HeaderCell className="" key={key+i}
                          sorted={column === key ? direction : null}
                          onClick={handleSort(key)}
                          >{value}
                          </Table.HeaderCell>)
                      }
                      return  null;
                  }).filter( e => !!e)
              }
          </Table.Row>
        </Table.Header>
          <thead className="">
          <tr className="">
             
          </tr>
          </thead>
          <tbody className="">
          {
              items.map( (e, i)=> {
                  return (
                      <tr className="" key={'row-'+i}>
                          {
                              keys.map( (key, keyIndex) => {
                                  return (<td className="" key={i+'-'+keyIndex}>{e[key] || ""}</td>);
                              })
                          }
                      </tr>
                  );
              })
          }
          </tbody>
          <tfoot className="">
          <tr className="">
              <th colSpan={keys.length} className="">
                <div style={{display: 'flex', justifyContent:'space-between', alignItems: 'center', width: '750px'}}>
                  <Pagination style={{height: 'fit-content'}} defaultActivePage={page} totalPages={pageCount} onPageChange={(e,d)=>{pageClick(e,d)}}/>
                  <Dropdown text='Oszlop beállítások' floating labeled button className='icon' style={{height: 'fit-content'}} pointing='bottom right' multiple>
                    <Dropdown.Menu style={{maxHeight: '400px',overflowY: 'auto',}}>
                      {
                        header.map((e, i) => {
                          return (<Checkbox label={e.text} style={{padding: '10px 5px', width: "100%"}} 
                            checked={e.isShow} key={i+'-column-option'} 
                            onClick={(event, data)=>{tableColumChange(event, data, e.key)}}/>)
                        })
                      }
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </th>
          </tr>
          </tfoot>
      </Table>
  );
}



export default App;
